<template>
	<article class="add_newsite_page">
		<section class="add_newsite_wrap" style="display: flex;justify-content: space-between;flex-direction: column;height: 100%;">
      <div>
        <div class="order-info flex_wrap"style="background:#006535;padding:0;margin-bottom: 10px;"@click="back">
         <i class="ivu-icon ivu-icon-ios-arrow-back" style="font-size:30px;color: white;"></i>
        </div>

        <div class="input_wrap a_i_center">
          <div style="width: 80px;">用户姓名</div>
          <input placeholder="联系人姓名" v-model="addressModel.Contact" />
        </div>

        <div class="input_wrap">
          <div style="width: 80px;">联系电话</div>
          <input placeholder="手机号码" type="tel" v-model="addressModel.Mobile" />
        </div>

        <div class="input_wrap">
          <div style="width: 80px;">选择地区</div>
          <span>{{ addressModel.Province }}/</span>
          <span>{{ addressModel.City }}/</span>
          <input class="select_site" readonly="readonly" placeholder="请选择区域" v-model="addressModel.District" @click="showDistrictList" />
        </div>

        <div class="input_wrap cus-address">
          <div style="width: 80px;">详细地址</div>
          <input type="text" placeholder="请输入地址信息" v-model="addressModel.Address" @input="getInputTipsList" />
          <i class="iconfont icon-shanchu2" @click="addressModel.Address = ''" v-if="addressModel && addressModel.Address != ''"></i>
          <ul class="relevance" v-show="inputTipsList.length > 0">
            <li v-for="(item, index, key) in inputTipsList" :key="key" @click="chooseTips(item)">
              <i>{{ item.name }}</i>
            </li>
          </ul>
        </div>
      </div>



			<div class="big-btn"><button class="btn save_btn" style="background: #459C71;border-radius: 50px;box-shadow: none;line-height: 40px;font-size: 20px !important;font-weight: bold;" @click="checkAddressOfDistrict()">保存</button></div>


		</section>
	</article>
</template>

<script>
import addressApi from '../request/addressApi';
import frequencyApi from '../request/frequencyApi';
import appointApi from '../request/appointApi';
export default {
	name: 'EditAddress',
	data() {
		return {
			type: '',
			id: '',
			addressModel: {},
			pickupPlaceList: [],
			inputTipsList: []
		};
	},
	activated() {
		// this.getPickupPlaceList();
		let that = this;
		this.addressModel = {};
		this.$nextTick(function() {
			that.type = that.$route.params.type;
			that.id = that.$route.params.id;
			if (that.type == 'edit') {
				that.getAddressModel();
			} else {
				let tmpModel = {
					UserID: 0,
					Province: '广东省',
					City: '中山市',
					District: '请选择区域',
					Address: '',
					Contact: '',
					Mobile: '',
					Status: true
				};
				that.addressModel = tmpModel;
				that.getPickupPlaceList(tmpModel.City);
			}
		});
	},
	methods: {
		getPickupPlaceList(city) {
			let that = this;
			this.pickupPlaceList = [];
			// this.$Spin.show();
			// frequencyApi.getPickupAreaPriceList('中山市').then(sucRes => {
			//   if (sucRes.success) {
			//     that.pickupPlaceList = sucRes.data;
			//   }
			//   that.$Spin.hide();
			// });
			AMap.service('AMap.DistrictSearch', function() {
				//回调函数
				var opts = {
					subdistrict: 1, //返回下一级行政区
					level: 'city', //查询的范围
					showbiz: false //查询行政级别为 市
				};
				//实例化DistrictSearch
				let districtSearch = new AMap.DistrictSearch(opts);
				//TODO: 使用districtSearch对象调用行政区查询的功能
				districtSearch.search(city, function(status, result) {
					//TODO : 按照自己需求处理查询结果
					console.log(result);
					that.pickupPlaceList = result.districtList[0].districtList;
				});
			});
		},
		getAddressModel() {
			let that = this;
			addressApi.getAddressList(this.$store.state.user.OpenId, this.id).then(sucRes => {
				if (sucRes.success) {
					that.addressModel = sucRes.data[0];
					that.getPickupPlaceList(that.addressModel.City);
				}
				that.$Spin.hide();
			});
		},
		checkAddressOfDistrict() {
			let that = this;
			if (
				this.addressModel.Address == '' ||
				this.addressModel.Province == '' ||
				this.addressModel.City == '' ||
				this.addressModel.District == '' ||
				this.addressModel.Contact == '' ||
				this.addressModel.Mobile == '' ||
				this.addressModel.Contact == null ||
				this.addressModel.Mobile == null
			) {
				this.$Message.warning('必要信息不完整！');
			} else if(this.addressModel.Mobile.length < 8 || this.addressModel.Mobile.length > 11){
        this.$Message.warning('手机号码长度错误,请校对！');
      }else if (this.addressModel.District == '请选择区域') {
				this.$Message.warning('请选择行政区');
			} else {
				appointApi.convertAddressToLocation(this.addressModel.City, this.addressModel.Address).then(sucRes => {
					if (sucRes.status == '1' && sucRes.info == 'OK' && sucRes.pois && sucRes.pois.length > 0) {
						let location = sucRes.pois[0].location;
						appointApi.convertLocationToAddress(location).then(sucRes2 => {
							if (sucRes2.status == '1' && sucRes2.info == 'OK') {
								let district = sucRes2.regeocode.addressComponent.township;
								let addressStr = sucRes2.regeocode.formatted_address;
								if (this.addressModel.District != district) {
									// this.addressModel.District = district;
									// this.saveAddress();
									alert(
										`当前地址所选行政区[${that.addressModel.District}-${
											that.addressModel.Address
										}]与地图计算行政区结果[${district}-${addressStr}]不符，不能进行正确计费，请致电0760-88880777反映相关情况，或更改相关地址信息后重试。`
									);
								} else {
									this.saveAddress();
								}
							}
						});
					} else {
						this.$Message.warning('当前地址计算座标失败！');
					}
				});
			}
		},
		saveAddress() {
			let that = this;
			// if (
			//   this.addressModel.Address == '' ||
			//   this.addressModel.Province == '' ||
			//   this.addressModel.City == '' ||
			//   this.addressModel.District == '' ||
			//   this.addressModel.Contact == '' ||
			//   this.addressModel.Mobile == '' ||
			//   this.addressModel.Contact == null ||
			//   this.addressModel.Mobile == null
			// ) {
			//   alert('必要信息不完整！');
			// } else if (this.addressModel.District == '请选择区域') {
			//   alert('请选择接送区域');
			// } else {
			addressApi.updateAddress(this.$store.state.user.OpenId, this.addressModel).then(sucRes => {
				if (sucRes.success) {
					this.$Message.success(sucRes.message);
					addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes2 => {
						if (sucRes2.success) {
							if (sucRes2.data.length == 1) {
								that.$router.go(-1);
							} else {
								that.$router.go(-1);
							}
						} else {
							that.$router.go(-1);
						}
					});
				}
			});
			// }
		},
		showDistrictList() {
			let that = this;
			let tmpArray = [];
			for (let i = 0; i < this.pickupPlaceList.length; i++) {
				let tmp = {
					label: this.pickupPlaceList[i].name,
					value: this.pickupPlaceList[i].name
				};
				tmpArray.push(tmp);
			}
			this.$weui.picker(tmpArray, {
				onConfirm(result) {
					that.addressModel.District = result[0].value;
				}
			});
		},
		// new
		getInputTipsList() {
			let that = this;
			AMap.plugin('AMap.Autocomplete', function() {
				// 实例化Autocomplete
				let autoOptions = {
					city: that.addressModel.City
				};
				let autoComplete = new AMap.Autocomplete(autoOptions);
				autoComplete.search(that.addressModel.City + that.addressModel.Address, function(status, result) {
					// console.log('autoComplete=>', result);
					// 搜索成功时，result即是对应的匹配数据
					if (result != 'NO_PARAMS' && result.tips && result.tips.length > 0) {
						that.$nextTick(function() {
							//that.isShowMap = false;
							that.inputTipsList = [];
							if (result.tips.length > 8) {
								for (var i = 0; i < 8; i++) {
									that.inputTipsList.push(result.tips[i]);
								}
							} else {
								that.inputTipsList = result.tips;
							}
						});
					}
				});
			});
		},
		// new
		chooseTips(item) {
			let that = this;
			this.inputTipsList = [];
			this.addressModel.Address = item.name;
		},
    back(){
       this.$router.go(-1);
    },
	}
};
</script>

<style scoped lang="less">
@import '../style/public';

.cus-address {
	position: relative;
}
.relevance {
	position: absolute;
	top: 1.4rem;
	left: 0.4rem;
	font-size: 1.5em;
}
.add_newsite_wrap .input_wrap {
	padding: 0 0.4rem;
	align-items: center;
	border-bottom: 1px solid #ddd;
	.flex_wrap;
}
.select_site {
	align-self: stretch;
}
.add_newsite_wrap .input_wrap > input,
.add_newsite_wrap .input_wrap > .textarea_warp {
	flex: 1;
	border: none;
	padding-top: 2px;
	outline: none;
}
.add_newsite_wrap .input_wrap > .textarea_warp {
	min-height: 2.5rem;
	font: 400 0.4rem / normal '微软雅黑';
	background-color: transparent;
	padding: 0.3rem 0;
}
.add_newsite_wrap .input_wrap:nth-last-child(2) {
	height: auto;
}
.add_newsite_wrap .input_wrap > span {
}
.add_newsite_wrap .input_wrap > input,
.add_newsite_wrap .input_wrap > span {
	padding: 0.3rem 0;
	background-color: transparent;
	font-size: 0.4rem;
}
.add_newsite_wrap .input_wrap > i {
	font-size: 0.5rem;
	margin: 0 5px;
}
.add_newsite_wrap .select_site::-webkit-input-placeholder,
.add_newsite_wrap .textarea_warp::-webkit-input-placeholder {
	/*margin-top: 2px;*/
	color: #e22222;
}
.add_newsite_wrap .btn_wrap,
.inputInformation_page .btn_wrap {
	margin-top: 0.5rem;
}

.big-btn {
	margin: 0.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/EditAddress.vue